import type { SideMenuCategory } from '@indutrust/shared-model';

/** Route segment placeholder replaced with the signed-in user's company id. */
export const SIDE_MENU_COMPANY_ID_PLACEHOLDER = ':companyId';

export type ResolveSideMenuCategoriesOptions = {
  companyId?: number;
};

function resolveRouteSegment(
  segment: string,
  companyId: number | undefined
): string | null {
  if (segment !== SIDE_MENU_COMPANY_ID_PLACEHOLDER) {
    return segment;
  }

  return companyId === undefined ? null : String(companyId);
}

function resolveItemRoute(
  route: string[],
  companyId: number | undefined
): string[] | null {
  const resolved: string[] = [];

  for (const segment of route) {
    const nextSegment = resolveRouteSegment(segment, companyId);

    if (nextSegment === null) {
      return null;
    }

    resolved.push(nextSegment);
  }

  return resolved;
}

/**
 * Resolves dynamic route placeholders in brand side-menu config using session
 * context (e.g. Team → `/company/:companyId/team`).
 */
export function resolveSideMenuCategories(
  categories: SideMenuCategory[],
  options: ResolveSideMenuCategoriesOptions = {}
): SideMenuCategory[] {
  const { companyId } = options;

  return categories.map((category) => ({
    ...category,
    items: category.items.flatMap((item) => {
      const route = resolveItemRoute(item.route, companyId);

      if (route === null) {
        return [];
      }

      return [{ ...item, route }];
    }),
  }));
}
